import { Injectable } from '@angular/core';
import { ModalBasicComponent } from '../components/modal-basic/modal-basic.component';

@Injectable({
  providedIn: 'root',
})
export class ModalServiceService {
  private modals: ModalBasicComponent[] = [];
  constructor() {}

  add(modal: any) {
    this.modals.push(modal);
  }

  getModal(id: string) {
    const modal = this.modals.find((x) => x.id === id);
    return modal;
  }

  remove(id: string) {
    this.modals = this.modals.filter((x) => x.id !== id);
  }

  open(id: string) {
    // console.log(this.modals);
    const modal: any = this.modals.find((x) => x.id === id);
    modal.open();
  }

  close(id: string) {
    const modal: any = this.modals.find((x) => x.id === id);
    modal.close();
  }
}
